import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';
import logo from '../assets/LOGO.png';

function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  const links = [
    { name: 'Home', to: '/' },
    { name: 'About', to: '/about' },
    { name: 'Projects', to: '/projects' },
    { name: 'Careers', to: '/careers' },
    { name: 'Contact', to: '/contact' },
  ];

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 50;
      setScrolled(isScrolled);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <header className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <a
        href="../index.html"
        className="luca-back-home"
        aria-label="Back to Luca Miro homepage"
        onClick={() => setOpen(false)}
      >
        <span className="luca-back-arrow" aria-hidden="true">←</span>
        <img
          src="../img/luca-miro-logo.png"
          alt="Luca Miro"
          className="luca-back-logo"
        />
      </a>
      <div className="navbar-container">
        <Link to="/" className="logo-link" onClick={() => setOpen(false)}>
          <img src={logo} alt="Studio 13 Logo" className="logo" />
        </Link>

        <nav className={`nav-links ${open ? 'open' : ''}`}>
          {links.map(link => (
            <Link 
              key={link.name} 
              to={link.to} 
              className={`nav-link ${isActive(link.to) ? 'active' : ''}`}
              onClick={(e) => {
                setOpen(false);
                if (link.name === 'About') {
                  if (location.pathname === '/' || location.pathname === '/about') {
                    e.preventDefault();
                    const element = document.getElementById('about-section');
                    if (element) {
                      element.scrollIntoView({ behavior: 'smooth' });
                    }
                  } else {
                    sessionStorage.setItem('scroll_to_about', 'true');
                  }
                }
              }}
            >
              {link.name}
            </Link>
          ))}
        </nav>

        <div className="hamburger" onClick={() => setOpen(!open)}>
          <span className={`hamburger-line ${open ? 'open' : ''}`}></span>
          <span className={`hamburger-line ${open ? 'open' : ''}`}></span>
          <span className={`hamburger-line ${open ? 'open' : ''}`}></span>
        </div>
      </div>
    </header>
  );
}

export default Navbar;
